var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DemandWriteSuccessDialog"},[_c('CgModalMiddle',{on:{"close":_vm.close}},[_c('div',{staticClass:"modal-content",attrs:{"slot":"modal_content"},slot:"modal_content"},[_vm._v("\n      111111\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }